import { action as apiAction } from 'api/Api'
import {
  remove
} from '../redux/bookmarks'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
}

export default (payload: Payload) => async dispatch => {
  const { id } = payload

  const optimisticAction = optimisticDispatch(dispatch, remove(id))

  try {
    await apiAction('RemoveBookmark', {
      activityId: id
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 401) {
      throw error
    }
  }
}
